import React, { useMemo } from "react";
import PageLayout from "../../component/pagelayout/PageLayout";
import "./ListView.scss";
import { DEFAULT_API_CONFIG } from "../../api/api-config";
import useDataFetch from "../../hooks/useDataFetch";
import {
  IFeature,
  IFeatureCollection,
  IFeatureToDisplay,
} from "../../utils/data-types";
import { digiThemeUuid } from "../../constants/Uuid";

const ListView = () => {
  const dataUrl = useMemo(() => {
    return `${DEFAULT_API_CONFIG.url}/features/${digiThemeUuid}/json`;
  }, []);

  const [data] = useDataFetch<IFeatureCollection>(dataUrl, "GET");

  const keysToInclude = useMemo(
    () => [
      "id",
      "osnid",
      "version_tag",
      "available_format",
      "osnid_description",
    ],
    []
  );

  const features = useMemo(() => {
    if (!data) return [];

    return data.features.map((feature: IFeature) => {
      const featureToDisplay = keysToInclude.reduce((acc, key) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc as any)[key] = feature[key as keyof IFeature];
        return acc;
      }, {} as IFeatureToDisplay);

      return featureToDisplay;
    });
  }, [data, keysToInclude]);

  return (
    <PageLayout>
      <div className="list-view">
        <div className="list-view__table">
          <div className="list-view__table-header">
            <div className="list-view__table-cell">ID</div>
            <div className="list-view__table-cell">OSN ID</div>
            <div className="list-view__table-cell">Version Tag</div>
            <div className="list-view__table-cell">Available Format</div>
            <div className="list-view__table-cell">OSN ID Description</div>
          </div>
          <div className="list-view__table-rows">
            {features &&
              features.map((feature) => {
                return (
                  <div key={feature.id} className="list-view__table-row">
                    <div className="list-view__table-cell">{feature.id}</div>
                    <div className="list-view__table-cell">{feature.osnid}</div>
                    <div className="list-view__table-cell">
                      {feature.version_tag}
                    </div>
                    <div className="list-view__table-cell">
                      {feature.available_format}
                    </div>
                    <div className="list-view__table-cell">
                      {feature.osnid_description}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default ListView;
